import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Clock } from 'lucide-react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <AnimatePresence data-id="element-306">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-accent/20 shadow-[0_-4px_20px_rgba(236,72,153,0.2)] px-4 py-3 flex items-center justify-between" data-id="element-307">
          <div className="flex flex-col" data-id="element-308">
            <div className="flex items-center gap-1 text-accent font-bold text-xs mb-0.5 animate-pulse" data-id="element-309">
              <Clock className="w-3 h-3" data-id="element-310" />
              <span data-id="element-311">Oferta expira pronto</span>
            </div>
            <div className="flex items-baseline gap-2" data-id="element-312">
              <span className="text-brown font-bold text-xl leading-none" data-id="element-313">
                $6.36
              </span>
              <span className="text-gray-400 text-xs line-through decoration-red-400" data-id="element-314">
                $97
              </span>
            </div>
          </div>

          <button onClick={scrollToOffer} className="bg-accent text-white px-6 py-3 rounded-full font-bold text-sm shadow-lg shadow-accent/30 flex items-center gap-2 active:scale-95 transition-transform" data-id="element-315">
            LO QUIERO
            <ArrowRight className="w-4 h-4" data-id="element-316" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}